import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessAnnouncementContainer} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessAnnouncementPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessAnnouncementPage;
  }

  render() {
    return (
      <MasterLayout>
        <MyBusinessAnnouncementContainer/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessAnnouncementPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessAnnouncementPage.jsx